import React from 'react'
import { Typography, Box } from '@mui/material'

const criteria = [
  'At least one Session has been created;',
  'Each Session has at least one Section;',
  'Each Section has at least one Page;',
  'Each Page has at least one block;',
  'Each Session Email has been configured.'
]

export const TooltipHelperText = () => {
  return (
    <div>
      <Typography>This Skill Bite is not valid.</Typography>
      <Typography>Please, make sure that all the below criteria have been met:</Typography>
      <Box
        component='ul' sx={{ margin: 0, padding: '8px' }} data-test='edit-skill-bite-publish-criteria-list'
      >
        {criteria.map((criteria, index) => {
          return (
            <Box
              key={index}
              component='li'
              data-test='edit-skill-bite-publish-criteria-list-item'
            >
              <Typography>
                {criteria}
              </Typography>
            </Box>
          )
        })}
      </Box>
    </div>
  )
}
